import React from "react";

import { Link } from "react-router-dom";
import OurPaymentChannels from "./OurPaymentChannels";
import bg1 from "../assets/images/bg_1.png";
import bg2 from "../assets/images/bg_2.png";
import CompatibleDevices from "./CompatibleDevices";
import FAQ from "./FAQ";
import ContactCTA from "./ContactCTA";

function Registration() {
  /* Pricing Page */
  const pricingPlans = [
    {
      name: "Lite Plan",
      price: 0,
      period: "monthly",
      currency: "RM",
      spec: ["Start Date : Immediate"],
      statement: "Essential Features for Small Businesses",
      tickpoint: ["Point-of-Sales", "Menu Management", "Product & Inventory", "Offline Payment Integration", "E-Invoice (30-days Free Trial)"],
      button: "SUBSCRIBE NOW",
      popular: false,
      link: "https://pos.vernpos.my/business/register?package=4",
    },
    {
      name: "Classic Plan",
      price: 39,
      period: "monthly",
      currency: "RM",
      spec: ["Start Date : Immediate", "Billing : Months"],
      statement: "Essential Features for F&B  and Retail Businesses",
      tickpoint: ["Everything in Lite Plan", "Table Management", "Invoice Management", "Preset Report"],
      button: "SUBSCRIBE NOW",
      popular: true,
      link: "https://pos.vernpos.my/business/register?package=5",
    },
    {
      name: "Elite Plan",
      price: 89,
      period: "monthly",
      currency: "RM",
      spec: ["Start Date : Immediate", "Billing : Months"],
      statement: "Advanced Tools for Growing Businesses",
      tickpoint: ["Everything in Classic Plan", "QR Code Ordering", "Delivery Integration", "Menu Modifiers", "Sub POS (2 Devices)"],
      button: "SUBSCRIBE NOW",
      popular: false,
      link: "https://pos.vernpos.my/business/register?package=6",
    },
  ];

  const premiumPlan = {
    name: "Premium Plan",
    price: 129,
    period: "monthly",
    currency: "RM",
    spec: [],
    statement: "Comprehensive Solution for Large-Scale Operations",
    tickpoint: [
      "Everything in Elite Plan",
      "Sub POS (Unlimited)",
      "Customer Relationship Management",
      "Accounting Software Integration",
      "Kitchen Display System",
      "Order Queue System",
    ],
    button: "JOIN THE WAITLIST",
    popular: false,
    link: "/",
  };

  const faqs = [
    {
      question: "What's included in each VernPOS plan?",
      answer: "Each plan provides access to the features listed for that specific tier. You can choose the plan that best fits your business needs.",
    },
    {
      question: "Are there any additional fees?",
      answer:
        "The subscription covers the software package selected. Hardware, third-party services, or optional add-ons may have separate charges if required.",
    },
    {
      question: "Can I upgrade or downgrade my plan?",
      answer: "Yes. You can adjust your plan based on your operational needs. Changes may follow your next billing cycle depending on the timing.",
    },
    {
      question: "Is support included?",
      answer: "All plans include access to standard support channels. Response times and available assistance may vary by plan.",
    },
    {
      question: "How does pricing work for multiple outlets or devices?",
      answer:
        "You may add additional outlets or terminals to your account. Costs may adjust based on the number of locations or devices you choose to link.",
    },
    {
      question: "Are updates included in my subscription?",
      answer: "Subscribers receive access to updates made available for their plan tier. Some advanced features may require a higher plan.",
    },
  ];

  return (
    <div
      id="background"
      style={{ backgroundImage: `url(${bg1})`, backgroundSize: "100% auto", backgroundRepeat: "no-repeat", backgroundPosition: "0 -200px" }}
    >
      <section className={`py-12 px-4 md:py-20 text-center md:-mb-1`} id="home">
        <div className="container mx-auto max-w-6xl">
          <Link className="border-2 border-black text-black px-8 py-3 font-bold rounded-full text-lg inline-block">VernPOS Pricing Price</Link>
          <h1 className="text-4xl md:text-6xl font-bold text-vern my-6">Your All-in-One POS Solution</h1>
          <p className="text-gray-700 font-roboto mb-8 text-[23px]">Fast, reliable, and effortless. Choose a plan that scales with your business.</p>
        </div>
      </section>

      <section className="py-6 px-2 text-center">
        <div className="flex flex-col md:flex-row mx-6 md:mx-auto max-w-6xl gap-5 text-left">
          {pricingPlans.map((plan, index) => (
            <div
              className="card flex flex-col bg-white rounded-[17px] border-2 flex-1 hover:-translate-y-4 transition-transform duration-300"
              key={index}
            >
              <div className="card-header">
                {plan.popular && <div className="bg-[#C9F3DA] rounded-t-[13px] p-4 font-medium text-lg">Most Popular</div>}
                <div className={`p-4 text-vern font-bold text-[24px] ${plan.popular ? "py-3" : ""}`}>{plan.name}</div>
              </div>
              <div className="card-body">
                <span className="text-4xl font-bold mb-2 ml-4 mr-2">{plan.price === 0 ? "Free" : `${plan.currency} ${plan.price.toFixed(2)}`}</span>
                <span className="text-[#90929B]">{plan.price !== 0 && `${plan.period}`}</span>
                <ul className="p-4 border-b-2">
                  {plan.spec.map((item, i) => (
                    <li key={i} className="flex items-center mb-1">
                      {/*<span className="text-green-500 mr-2">✓</span>*/}
                      {item}
                    </li>
                  ))}
                </ul>
                <p className="text-gray-600 font-bold text-lg p-4 border-b-2">{plan.statement}</p>
                <div className="rounded-[14px] border-2 m-4 font-sans">
                  <ul className="m-4">
                    {plan.tickpoint.map((point, i) => (
                      <li key={i} className="flex items-center text-xl font-roboto font-medium mb-1">
                        <img src={"../frame.png"} alt="" className="w-8 h-8 mr-2 mb-1" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="card-footer mt-auto p-4 border-t-2">
                {plan.popular ? (
                  <a
                    href={plan.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full border-2 border-vern bg-vern text-white py-2 px-4 rounded-full font-medium hover:scale-105 transition-transform duration-300 inline-block text-center"
                  >
                    {plan.button}
                  </a>
                ) : (
                  <a
                    href={plan.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full border-2 border-vern text-vern py-2 px-4 rounded-full font-medium hover:bg-vern hover:text-white inline-block text-center"
                  >
                    {plan.button}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="my-8 md:my-28">
          <div className="font-sans text-2xl">All plans include secure payment processing and data backup</div>
          <div className="flex justify-center my-4 text-lg font-roboto">
            <ul className="flex flex-col md:flex-row m-4">
              <li className="flex items-center mr-8">
                <img src={"../frame.png"} alt="" className="w-8 h-8 mr-2 mb-1" />
                No setup fees
              </li>
              <li className="flex items-center mr-8">
                <img src={"../frame.png"} alt="" className="w-8 h-8 mr-2 mb-1" />
                Cancel anytime
              </li>
              <li className="flex items-center">
                <img src={"../frame.png"} alt="" className="w-8 h-8 mr-2 mb-1" />
                Integrated payments
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div
        id="background"
        style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "repeat",
          backgroundPosition: "0 -200px",
          borderWidth: "2px",
          borderColor: "#EDEDED",
          borderStyle: "solid",
        }}
        className="pb-24"
      >
        <section className={`py-12 px-4 text-center md:-mb-1`} id="home">
          <div className="container mx-auto max-w-6xl">
            <h1 className="text-4xl md:text-6xl font-bold my-6">Coming Soon</h1>
            <p className="text-gray-700 font-roboto mb-8 text-[23px]">Our most powerful features are on the way.</p>
          </div>
        </section>

        <div className="flex flex-col md:flex-row mx-6 md:mx-auto max-w-6xl gap-5 text-left">
          <div className="card my-auto bg-white rounded-[17px] border-2 flex-1">
            <div className="card-header">
              <div className={`p-4 text-vern font-bold text-[24px] ${premiumPlan.popular ? "py-3" : ""}`}>{premiumPlan.name}</div>
            </div>
            <div className="card-body">
              <span className="text-4xl font-bold mb-2 ml-4 mr-2">
                {premiumPlan.price === 0 ? "Free" : `${premiumPlan.currency} ${premiumPlan.price.toFixed(2)}`}
              </span>
              <span className="text-[#90929B]">{premiumPlan.price !== 0 && `${premiumPlan.period}`}</span>
              <ul className="p-4 border-b-2">
                {premiumPlan.spec.map((item, i) => (
                  <li key={i} className="flex items-center mb-1">
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-gray-600 font-bold text-lg p-4 border-b-2">{premiumPlan.statement}</p>
              <div className="rounded-[14px] border-2 m-4 font-sans">
                <ul className="m-4">
                  {premiumPlan.tickpoint.map((point, i) => (
                    <li key={i} className="flex items-center text-xl font-roboto font-medium mb-1">
                      <img src={"../frame.png"} alt="" className="w-8 h-8 mr-2 mb-1" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="card-footer p-4 border-t-2">
              <a
                href={"/"}
                target="_top"
                rel="noopener noreferrer"
                className="w-full border-2 pointer-events-none py-2 px-4 rounded-full font-medium inline-block text-center text-white border-gray-300 bg-gray-300"
              >
                JOIN THE WAITLIST
              </a>
            </div>
          </div>
        </div>
      </div>

      <OurPaymentChannels />

      <CompatibleDevices />

      <div className="max-w-6xl mx-auto px-4 py-8">
        <FAQ title="Frequently Asked Questions" faqs={faqs} />
      </div>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <ContactCTA />
      </div>
    </div>
  );
}

export default Registration;
